function handleStaleChunkError() {
  alert('A new version of Tango Portal is available. Please refresh.')
  window.location.reload()
}

window.addEventListener('error', (event) => {
  if (
    event.error instanceof TypeError &&
    /Cannot read properties of undefined \(reading 'call'\)/.test(
      event.error.message,
    ) &&
    /__webpack_require__/.test(event.error.stack || '')
  ) {
    console.warn('Stale chunk detected (error):', event.error)
    handleStaleChunkError()
  }
})

window.addEventListener('unhandledrejection', (event) => {
  if (
    event.reason instanceof TypeError &&
    /Cannot read properties of undefined \(reading 'call'\)/.test(
      event.reason.message,
    ) &&
    /__webpack_require__/.test(event.reason.stack || '')
  ) {
    console.warn('Stale chunk detected (promise rejection):', event.reason)
    handleStaleChunkError()
  }
})

// Test functions to simulate errors for testing purposes on the window
// Callable from the console to trigger the error handling logic
window.__testStaleChunkWebpackTypeError = () => {
  const error = new TypeError(
    "Cannot read properties of undefined (reading 'call')",
  )
  error.stack = 'at __webpack_require__ (fake/path.js:1:1)'
  const event = new ErrorEvent('error', { error })
  window.dispatchEvent(event)
}

window.__testStaleChunkWebpackError = () => {
  const error = new Error(
    "Cannot read properties of undefined (reading 'call')",
  )
  error.stack = 'at __webpack_require__ (fake/path.js:1:1)'
  const event = new ErrorEvent('error', { error })
  window.dispatchEvent(event)
}
